module.exports = "/_next/static/images/waves-f1b7456f2fa9c8ba5ef2d3a0120a7b32.svg";